<template>
	<DataSourceButton
		:value="value"
		:source="source"
		:transformer="transformer"
	/>
</template>

<script setup lang="ts">
import type { sources } from "./dataSources";

defineProps<{
	value: unknown;
	source: keyof typeof sources;
	transformer?: (value: unknown) => unknown;
}>();
</script>
